import { reverseDate } from 'js/app/utils/common.util';

export const convertDate = (date, time) => {
    return new Date(`${reverseDate(date)}T${time}.000Z`).getTime();
};

export const getCurrentDateObj = (serverDate) => {
    const today = new Date(serverDate);
    const dd = String(today.getUTCDate()).padStart(2, '0');
    const mm = String(today.getUTCMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = today.getUTCFullYear();

    return {
        dd,
        mm,
        yyyy,
        fullDate: `${dd}-${mm}-${yyyy}`,
        weekDayLong: today.toLocaleString('en-GB', { weekday: 'long', timeZone: 'UTC' })
    };
};
